'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import type { HotelRoomConfig } from '../searchForm/hooks/useHotelSearchManager'
import { HotelGuestsSelector } from './hotelGuestsSelector'

interface HotelGuestsSelectorWrapperProps {
    open: boolean
    onOpen: () => void
    onClose: () => void
    roomConfigs: HotelRoomConfig[]
    minRooms: number
    maxRooms: number
    minAdultsPerRoom: number
    maxAdultsPerRoom: number
    minChildrenPerRoom: number
    maxChildrenPerRoom: number
    onRoomCountChange: (count: number) => void
    onRoomAdultsChange: (roomIndex: number, adults: number) => void
    onRoomChildrenChange: (roomIndex: number, children: number) => void
}

const HotelGuestsSelectorWrapper: React.FC<HotelGuestsSelectorWrapperProps> = ({
    open,
    onOpen,
    onClose,
    roomConfigs,
    minRooms,
    maxRooms,
    minAdultsPerRoom,
    maxAdultsPerRoom,
    minChildrenPerRoom,
    maxChildrenPerRoom,
    onRoomCountChange,
    onRoomAdultsChange,
    onRoomChildrenChange
}) => {
    const t = useTranslations('common')

    return (
        <HotelGuestsSelector
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            roomConfigs={roomConfigs}
            minRooms={minRooms}
            maxRooms={maxRooms}
            minAdultsPerRoom={minAdultsPerRoom}
            maxAdultsPerRoom={maxAdultsPerRoom}
            minChildrenPerRoom={minChildrenPerRoom}
            maxChildrenPerRoom={maxChildrenPerRoom}
            onRoomCountChange={onRoomCountChange}
            onRoomAdultsChange={onRoomAdultsChange}
            onRoomChildrenChange={onRoomChildrenChange}
            onApply={onClose}
            t={t}
        />
    )
}

export { HotelGuestsSelectorWrapper as HotelGuestsSelector }
export default HotelGuestsSelectorWrapper
